import { ReactNode } from "react";

import MainView from "./UI";
import { PastNotesControllerContextProvider } from "@ui/modules/PastNotes/Controller";

import { ENotesEntity, EPipelineSlug } from "@type/api/management/types";

type TPastNotesParams = {
  pipelineSlug?: EPipelineSlug;
  entityType?: ENotesEntity;
  label?: ReactNode;
};

const PastNotes = ({ pipelineSlug, entityType, label }: TPastNotesParams) => {
  return (
    <PastNotesControllerContextProvider
      pipelineSlug={pipelineSlug}
      entityType={entityType}
      label={label}
    >
      <MainView />
    </PastNotesControllerContextProvider>
  );
};

export default PastNotes;
